/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Nav Toggle View.
 * Toggles the nav view via the hamburger nav.
 * 
 * @author John Pobojewski <https://john.pobojewski.com
 */

class NavToggleView {
	constructor() {}

	init() {
		console.log("NavToggleView.init()");

		// Select all nav elements with the class "toggle-view"
		document.querySelectorAll("nav.toggle-view").forEach((navElement) => {

			// Add click event to all elements with data-action="close-nav"
			document.querySelectorAll("a[data-action='close-nav']").forEach((el) => {
				el.addEventListener("click", function (e) {
					e.preventDefault();
					navElement.classList.add("hide");
				});
			});

			// Add click event to all elements with data-action="show-nav"
			document.querySelectorAll("a[data-action='show-nav']").forEach((el) => {
				el.addEventListener("click", function (e) {
					e.preventDefault();
					navElement.classList.remove("hide");
				});
			});
		});
	}
}

export default new NavToggleView();
